/* WhatIs — sección de fundamento: problema · solución · diferencia.
   Fondo levemente más oscuro que el global para que las cards blancas resalten. */

.section {
  position: relative;
  isolation: isolate;
  overflow: hidden;
  background: var(--blue-50);
  padding-block: var(--space-20);
}

@media (min-width: 768px) {
  .section {
    padding-block: var(--space-24);
  }
}

@media (min-width: 1024px) {
  .section {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

/* ─── Grid de tarjetas ─── */

.grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-4);
}

@media (min-width: 768px) {
  .grid {
    grid-template-columns: repeat(3, 1fr);
    gap: var(--space-6);
  }
}

@media (min-width: 1024px) {
  .grid {
    gap: var(--space-8);
  }
}

/* ─── Card ─── */

.card {
  position: relative;
  background: var(--color-surface);
  border: 1px solid var(--color-border-subtle);
  border-radius: var(--radius-xl);
  padding: var(--space-6);
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  box-shadow: var(--shadow-sm);

  /* Reveal — estado inicial. Stagger via --i (0/1/2) → delay 0/120/240ms */
  opacity: 0;
  transform: translateY(20px);
  transition:
    opacity 600ms var(--ease-decelerate),
    transform 600ms var(--ease-decelerate),
    box-shadow var(--duration-base) var(--ease-standard);
  transition-delay: calc(var(--i, 0) * 120ms);
  will-change: transform, opacity;
}

@media (min-width: 768px) {
  .card {
    padding: var(--space-10);
    gap: var(--space-4);
  }
}

.revealed .card {
  opacity: 1;
  transform: translateY(0);
}

/* Hover — solo después del reveal para no chocar con la animación de entrada.
   Lift 6px + sombra más intensa, sin delay para que sea inmediato. */
.revealed .card:hover,
.revealed .card:focus-within {
  transform: translateY(-6px);
  box-shadow: var(--shadow-lg);
  transition-delay: 0ms;
}

/* ─── Icono ─── */

.iconWrap {
  width: 56px;
  height: 56px;
  border-radius: var(--radius-full);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: var(--space-2);
  transition: transform var(--duration-base) var(--ease-standard);
}

.revealed .card:hover .iconWrap,
.revealed .card:focus-within .iconWrap {
  transform: rotate(6deg) scale(1.08);
}

/* Tones — neutral (problema) · primary (solución) · accent (diferencia) */
.card[data-tone='neutral'] .iconWrap {
  background: var(--sand-200);
  color: var(--sand-700);
}

.card[data-tone='primary'] .iconWrap {
  background: var(--blue-50);
  color: var(--blue-500);
}

.card[data-tone='accent'] .iconWrap {
  background: var(--jade-50);
  color: var(--jade-600);
}

/* ─── Texto ─── */

.cardTitle {
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: var(--text-xl);
  line-height: 1.2;
  letter-spacing: -0.01em;
  color: var(--color-text);
  margin: 0;
}

.cardBody {
  font-family: var(--font-body);
  font-size: var(--text-base);
  line-height: 1.6;
  color: var(--color-text-muted);
  margin: 0;
}
